export const MotionDuration = {
  Rapid: '150ms',
  Gentle: '300ms',
  Slow: '450ms',
};

export const MotionCurve = {
  /** ease */
  LUXEaseOutStandard: 'cubic-bezier(0.33, 0.86, 0.2, 1)',
  LUXEaseInOut: 'cubic-bezier(0.25, 0, 0.25, 1)',
  LUXEaseOutCubic: 'cubic-bezier(0.33, 1, 0.68, 1)',
  LUXEaseInCubic: 'cubic-bezier(0.32, 0, 0.67, 0)',
  LUXEaseOvershoot: 'cubic-bezier(0.4, 1.25, 0.26, 1)',
  LUXLinear: 'linear',
  LUXEaseOutSine: 'cubic-bezier(.61, 1, .88, 1)',
  LUXEaseOutQuad: 'cubic-bezier(.5, 1, .89, 1)',
  LUXEaseOutQuart: 'cubic-bezier(.25, 1, .5, 1)',
  LUXEaseOutQuint: 'cubic-bezier(.22, 1, .36, 1)',
  LUXEaseOutExpo: 'cubic-bezier(.16, 1, .3, 1)',
  LUXEaseInSine: 'cubic-bezier(.12, 0, .39, 0)',
  LUXEaseInQuad: 'cubic-bezier(.11, 0, .5, 0)',
  LUXEaseInQuart: 'cubic-bezier(.5, 0, .75, 0)',
  LUXEaseInQuint: 'cubic-bezier(.64, 0, .78, 0)',
  LUXEaseInExpo: 'cubic-bezier(.7, 0, .84, 0)',
  LUXEaseInOutSine: 'cubic-bezier(.37, 0, .63, 1)',
  LUXEaseInOutQuad: 'cubic-bezier(.45, 0, .55, 1)',
  LUXEaseInOutCubic: 'cubic-bezier(.65, 0, .35, 1)',
  LUXEaseInOutQuart: 'cubic-bezier(.76, 0, .24, 1)',
  LUXEaseInOutQuint: 'cubic-bezier(.83, 0, .17, 1)',
  LUXEaseInOutExpo: 'cubic-bezier(.87, 0, .13, 1)',
  LUXEaseInBack: 'cubic-bezier(.36, 0, .66, -.56)',
  LUXEaseOutBack: 'cubic-bezier(.34, 1.56, .64, 1)',
};
